import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";
import {
    AdaptivityContext,
    getGUID,
    last_store_klients_items_key,
    setQuizStep,
    store_klients_items_key
} from "./constants";
import {
    Button, ButtonGroup,
    Cell, Div, FormItem,
    List,
    ModalPage,
    ModalPageHeader,
    ModalRoot, Pagination,
    PanelHeaderButton,
    RichCell,
    Search,
    Spinner, SplitCol, SplitLayout, Switch
} from "@vkontakte/vkui";
import React from "react";
import * as constants from "./constants";
import {Icon20AddCircleFillGreen, Icon24BrowserBack, Icon24Dropdown, Icon24Search} from "@vkontakte/icons";


class SelectList extends BaseComponent {


    constructor() {
        super();
        const state = {
            loading: false,
            items: [],
            search: '',
            page: 1,
            cnt_items: 0,
            append: false,
            totalPages: 1,
            showSearch: true,
            current_brand: null
        }

        this.state = {
            ...this.state,
            ...state
        }

    }

    checkScrollInterval = null

    componentDidMount() {
        super.componentDidMount()
        this.getItems()
        this.checkScrollInterval = setInterval(() => this.checkScroll(), 2000)
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        if (this.checkScrollInterval) {
            clearInterval(this.checkScrollInterval)
        }
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.activeModal !== this.props.activeModal && this.props.activeModal) {
            this.getItems()
        }
    }

    checkScroll = () => {


        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems('', true, page)


        }
    }

    handleScroll() {
        console.log('scroll!')
        this.checkScroll()
    }


    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({loading: true, page: page})
            setTimeout(() =>
                this.getItems(this.state.search, false, page), 600)
        }
    }

    getItems(search_ = '', append = false, page: 1) {
        if (this.props.items != undefined) {
            let items = [];
            this.props.items.map((el, i) => {
                items.push({name: el.Значение, external_id: el.Код, id: el.Код, descr: el.Тип})
                this.setState({items: items});
            })
        } else {
            const search = search_ ? search_ : this.state.search


            append = append == undefined ? false : append
            if (page == undefined) {
                page = this.state.page;
            }

            let sAjaxSource = '/?app=' + this.props.app + '&act=' + this.props.act
            if (this.props.params) {
                sAjaxSource = sAjaxSource + '&' + this.props.params
            }
            this.setState({loading: true})

            BaseApi.post(sAjaxSource, {search, page, epp: AdaptivityContext.isMobile ? 10 : 20},
            ).then((response) => {

                this.setState({loading: false})
                const items = append ? this.state.items : []
                let results = response.data.results
                let oldStoreKlients = localStorage.getItem(store_klients_items_key)
                if (!oldStoreKlients) {
                    oldStoreKlients = {}
                } else {
                    oldStoreKlients = JSON.parse(oldStoreKlients)
                }
                Object.keys(oldStoreKlients).map((key) => {
                    results.push(oldStoreKlients[key])
                })
                results.map((el, i) => {
                    el.name = el.title
                    el.checked = this.props.current_item && this.props.current_item.collections && this.props.current_item.collections[el.id] ? true : false
                    el.uid = el.id
                    el.id = el.external_id ?? el.id
                    el.descr = el.descr ?? el.INN

                    items.push(el)
                })

                this.setState({items})

                this.setState({cnt_items: response.data.iTotalRecords})
                this.setState({totalPages: response.data.iTotalPages})

                /*             if (response.data.iTotalPages * 1 > 0) {
                                 setTimeout(() => {
                                     this.checkScroll()
                                 }, 500)
                             }*/
            })
        }

    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }
    searchInterval = null

    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({search: state.target.value});
        this.searchInterval = setInterval(() => {
            clearInterval(this.searchInterval)
            this.setState({loading: true, page: 1})
            this.getItems(this.state.search, false, 1)
        }, state.target.value == '' ? 500 : 1000)

    }

    selectObject(index) {

        const item = this.state.items[index]

        if (this.props.no_multiselect) {
            this.setState({search: '', page: 1, items: []})
            this.props.selectObject(item)
        } else {
            item.checked = !item.checked
            window.postMessage({type: 'selectListObject', item, index})
        }
    }

    renderRow(item, index, last_store_klients_id = null) {

        return <RichCell key={'select_obj' + index}
                         onClick={() => this.selectObject(index)} multiline
                         style={{border: item.external_id && item.external_id == last_store_klients_id ? '1px solid orange' : 'inherit'}}
                         subhead={item.descr}
                         after={!this.props.no_multiselect &&
                             <Switch onClick={() => this.selectObject(index)} checked={item.checked}/>}
        >
            {item.name}
        </RichCell>
    }

    renderCreateForm() {

    }

    render(chilrens = {}) {

        const last_store_klients_id = localStorage.getItem(last_store_klients_items_key)

        const empty_rows_message = this.props.empty_rows_message ?? 'Ничего не найдено'
        const Alphabet = chilrens.alphabet ?? null
        return (
            <ModalRoot activeModal={this.props.activeModal}>
                <ModalPage
                    id={constants.MODAL_SELECT_LIST_ADD}
                    onClose={() => this.closeList()}
                    settlingHeight={100}
                    style={{zIndex: 9999999999999}}
                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={() => this.closeList()}><Icon24BrowserBack/></PanelHeaderButton>}

                        >
                            {this.props.modal_title ? this.props.modal_title : this.props.title}
                        </ModalPageHeader>
                    }
                >
                    <Div style={{paddingBottom: '150px'}}>
                        {this.renderCreateForm()}
                    </Div>
                </ModalPage>

                <ModalPage
                    id={constants.MODAL_SELECT_LIST}
                    onClose={() => this.closeList()}

                    settlingHeight={100}
                    style={{zIndex: 9999999999999}}
                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={() => this.closeList()}><Icon24BrowserBack/></PanelHeaderButton>}
                                         after={
                                             <div style={{display: 'flex'}}>
                                                 {this.props.setActiveModal && <PanelHeaderButton

                                                     onClick={() => {
                                                         if (this.props.isOffline) {
                                                             window.postMessage({
                                                                 type: 'error',
                                                                 text: 'В режиме offline невозможно добавить стенд'
                                                             })
                                                             return
                                                         }
                                                         this.setState({current_brand: {id: -1}})
                                                         this.props.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
                                                     }}>
                                                     <Icon20AddCircleFillGreen/>
                                                 </PanelHeaderButton>}
                                                 <PanelHeaderButton
                                                     onClick={() => this.props.searchAct && this.props.current_user && this.props.current_user.meta.settings.search_klients_by_phone == '1' ?
                                                         this.props.searchAct() : this.toggleSearch()}>
                                                     <Icon24Search/>
                                                 </PanelHeaderButton>

                                             </div>
                                         }
                        >
                            {this.state.showSearch ?
                                <form onSubmit={e => {
                                    e.preventDefault();
                                    e.stopPropagation()
                                }}>
                                    <Search autoFocus

                                            theme="header"
                                            placeholder="Поиск"
                                            value={this.state.search}
                                            onChange={this.onSearchChange}
                                            onIconClick={this.toggleSearch}

                                            style={{flexGrow: '1', maxWidth: '350px'}}
                                    />
                                </form> : (this.props.modal_title ? this.props.modal_title : this.props.title)}{/**/}

                        </ModalPageHeader>
                    }

                >  {Alphabet ?? ''}
                    {this.props.header_info_message && <div style={{top: '0px'}}
                                                            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
                        <Div>
                            <p>{this.props.header_info_message}</p>
                        </Div>
                    </div>}

                    <Div style={{
                        paddingBottom: '150px',
                        width: (Alphabet ? (AdaptivityContext.isMobile ? '88%' : '92%') : "inherit")
                    }}>

                        <List className="selectList-list"
                              onScroll={this.handleScroll}>
                            {this.state.items && this.state.items.map((item, index) => (
                                this.renderRow(item, index, last_store_klients_id)
                            ))}
                            {AdaptivityContext.isMobile || true ?
                                <div ref={this.ref} key="loaderSelectList"
                                     style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                                    <Cell before="Запрашиваем данные с сервера"
                                          after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                                    <Cell before="Запрашиваем данные с сервера"
                                          after={<Spinner size="large"/>}></Cell> : ""}
                            {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                                <div
                                    style={{background: "whitesmoke", position: "fixed", bottom: "16%", zIndex: '99'}}>
                                    <Pagination currentPage={this.state.page}
                                                totalPages={this.state.totalPages}
                                                onChange={this.setPage}/>
                                </div> : ''}
                            {this.state.items.length > 0 || this.state.loading ? '' :
                                <RichCell key={'sel_lst0'} className="empty_rows_message"

                                >
                                    {empty_rows_message}
                                </RichCell>}
                        </List>
                    </Div>

                    <Div className={AdaptivityContext.isMobile ? 'action-board' : 'action-board desktop'}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => this.closeList()}
                            >Подтвердить</Button>
                        </ButtonGroup>
                    </Div>

                </ModalPage>
            </ModalRoot>)

    }

    closeList = () => {
        this.setState({search: '', page: 1, items: []})
        this.props.modalBack()
    }
}

export default SelectList